import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationsEn from "../locales/en/translation.json";
import translationsIt from "../locales/it/translation.json";
import translationsFr from "../locales/fr/translation.json";

const resources = {
  en: { translation: translationsEn },
  it: { translation: translationsIt },
  fr: { translation: translationsFr },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    // the translations
    // (tip move them in a JSON file and import them,
    // or even better, manage them via a import Survey from './pages/survey';
    // UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
    resources,
    lng: "en", // if you're using a language detector, do not define the lng option
    fallbackLng: "en",
    interpolation: {
      escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    },
  });

export default i18n;
